import _ from 'underscore';
import { Component } from 'react';
import { IconButton } from '@workramp/ui';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import withSearchResultsManagement from '~/components/common/search/with-search-results-management';
import withAlgoliaSearch from '~/components/common/search/with-algolia-search';
import DropdownEnabledSearchBar from '../common/search/dropdown-enabled-search-bar';
import AdminIndices from '../../algolia/admin/admin-indices';
import AdminQuickSearchResult from '../../algolia/admin/admin-quick-search-result';
/**
  Internal Admin Search from ItemFolderPane
*/
class HiddenSearchBarBase extends Component {
  constructor(props) {
    super(props);

    this.state = { showSearch: false };
  }

  render() {
    return this.state.showSearch ? this.getSearchBar() : this.getIcon();
  }

  getSearchBar = () => (
    <div ref={(searchContainer) => (this.searchContainer = searchContainer)} className="hidden-search">
      <DropdownEnabledSearchBar
        allowReset
        handleItemSelect={this.handleItemSelect}
        onBlur={this.hideSearchInput}
        onReset={this.hideSearchInput}
        placeholder="Search Training"
        renderResult={(results, isActive) => this.renderAdminQuickSearchResult(results, isActive)}
        results={this.props.results}
        search={this.search}
        searching={this.props.searching}
      />
    </div>
  );

  renderAdminQuickSearchResult = (results, isActive) => (
    <AdminQuickSearchResult
      {...results}
      isActive={isActive}
      handleFolderClick={this.handleFolderClick}
      lastEditedByPosition="below"
    />
  );

  getIcon = () => (
    <div className="hidden-search-icon">
      <IconButton
        label="Search"
        iconName="search:regular"
        variant="text"
        color="secondary"
        onPress={this.showSearchInput}
      />
    </div>
  );

  search = (query) => {
    if (query) {
      const searchId = this.props.beforeSearch();

      this.props.search(query, this.afterSearch.bind(this, searchId), {
        offset: 0,
        length: 50,
        // analyticsTags are used to filter data in search analytics
        analyticsTags: ['internal', 'admin', `enterprise_id:${getCurrentUser().enterpriseId}`],
      });
    } else {
      this.props.clear();
    }
  };

  afterSearch = (searchId, results) => {
    this.props.filter(results, (filteredResults) => {
      let formattedResults = this.props.format(filteredResults);
      formattedResults = _.flatten(formattedResults);

      this.props.afterSearch(searchId, formattedResults);
    });
  };

  handleItemSelect = (selectedItem) => {
    if (selectedItem.type === AssetPickerTypes.FOLDER) {
      this.handleFolderClick(selectedItem.searchResult);
      return;
    }
    this.props.handleItemSelect(selectedItem);
  };

  handleFolderClick = (item) => {
    this.props.handleFolderClick(item);
    this.props.clear();
    this.hideSearchInput();
  };

  showSearchInput = () => {
    this.setState({ showSearch: true }, () => {
      $(this.searchContainer).find('input').focus();
    });
  };

  hideSearchInput = () => {
    this.setState({ showSearch: false });
  };
}

const HiddenSearchBar = withSearchResultsManagement(withAlgoliaSearch(HiddenSearchBarBase, AdminIndices.getAll()));
export default HiddenSearchBar;
